import { ButtonGroup as JoyButtonGroup, ButtonGroupProps } from '@mui/joy';

import { ActionButton } from 'core/components';
import { ITableAction } from 'core/types';

interface IProps extends ButtonGroupProps {
  buttons: ITableAction[];
}

const ButtonGroup = ({ buttons, ...rest }: IProps) => {
  return (
    <JoyButtonGroup {...rest}>
      {buttons.map((action: ITableAction, index: number) => (
        <ActionButton key={`${action?.label}-${index}`} action={action} />
      ))}
    </JoyButtonGroup>
  );
};

export default ButtonGroup;
